import React from "react";
import { classNames } from "../../common/util/util-helpers";

export default function FieldText({item = {}, onChange}) {
    if (!item.props) {
        item.props = {}
    }

    return (
        <input
            id={item.props.id ?? item.name}
            type={item.type}
            onChange={(event) => {
                onChange(item.name, event.target.value);
            }}
            name={item.name}
            value={item.value}
            placeholder={item?.props?.placeholder}
            disabled={item.disabled}
            maxLength={item.props.max}
            autoFocus={item.props.autofocus}
            className={
                classNames(
                    item?.props?.className ?? "form-control",
                    !!item.errorMessage ? item?.metadata?.errorClass ?? "form-control-error" : undefined
                )
            }
        />
    )
}